import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../../axios"
import qs from "qs"
import Alert from "react-s-alert";

class Pembayaran extends Component {

    constructor(props) {
        super(props);
        this.state = {
            payment_nominal:"",
            payment_remark:"",
            channel_id:1,
            payment_misc:"",
            payment_status:"Berhasil",
            created_by:"",
            isButtonLoading: false,
            isLoading: false
        };
        this.handleToggle = this.handleToggle.bind(this)
		this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
    }

    handleToggle() {
        this.props.toggleModal()
    }

    handleSubmit() {
        this.setState({ isButtonLoading: true });
        const url = '/payment/trans/add';

        let newState = {
            created_by:localStorage.SISMART_USER_ID,
            payment_misc: this.props.finance_misc,
            siswa_id: this.props.siswa_id,
            channel_id:this.state.channel_id,
            payment_status:this.state.payment_status,
            finance_name: this.props.finance_name,
            nominal_balance: this.props.nominal_balance,
            payment_nominal: this.state.payment_nominal,
            payment_remark: this.state.payment_remark
        };
        

        axios({
            method: "post",
            url: url,
            data: qs.stringify(newState)
        })

        .then(response => {
            const result = response.data;

            if (result.success) {
                window.location.reload();
                Alert.success(result.message);
            } else {
                if (Array.isArray(result.message)) {
                    result.message.map(item => {
                        Alert.error(item);
                        return true;
                    });
                } else {
                    Alert.error(result.message);
                }

                this.setState({ isButtonLoading: false });
            }
        })
        
        .catch(error => {
            console.log(error);
            this.setState({ isButtonLoading: false });
            Alert.error("Gagal terhubung ke server!");
        });
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.handleToggle} className="modal-primary">
                <ModalHeader toggle={this.handleToggle}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    {/*Form*/}
                            <table className="col-md-12">
                                <tr>
                                    <td width="25%">
                                        Nama Tagihan
                                    </td>
                                    <td width="5%">:</td>
                                    <td width="70%">
                                        <input
                                            type="text"
                                            name="finance_name"
                                            disabled="disabled"
                                            style={{
                                                padding: "3px 7px",
                                                border: "1px solid #ccc",
                                                width: "100%"
                                            }}
                                            value={this.props.finance_name}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Nominal Tagihan
                                    </td>
                                    <td>:</td>
                                    <td>
                                        <input
                                            type="text"
                                            name="nominal_balance"
                                            disabled="disabled"
                                            style={{
                                                padding: "3px 7px",
                                                border: "1px solid #ccc",
                                                width: "100%"
                                            }}
                                            value={this.props.nominal_balance}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Nominal Bayar
                                    </td>
                                    <td>:</td>
                                    <td>
                                        <input
                                            type="text"
                                            name="payment_nominal"
                                            style={{
                                                padding: "3px 7px",
                                                border: "1px solid #ccc",
                                                width: "100%"
                                            }}
											onChange={this.handleChange}
                                            value={this.state.payment_nominal}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Deskripsi Singkat
                                    </td>
                                    <td>:</td>
                                    <td>
										<textarea
											name="payment_remark"
											type="number"
											className="form-control"
											placeholder="Deskripsi Singkat"
											onChange={this.handleChange}
											value={this.state.payment_remark}
										/>
                                    </td>
                                </tr>
                            </table>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleSubmit}>{this.props.modalSubmitText}</Button>{' '}
                    <Button color="secondary" onClick={this.handleToggle}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

Pembayaran.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    nominal_balance: PropTypes.func.isRequired,
    finance_name: PropTypes.func.isRequired,
    siswa_id: PropTypes.func.isRequired,
    payment_misc: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
} 

export default Pembayaran


// WEBPACK FOOTER //
// ./src/views/IuranSiswa/Pembayaran.js